import { FunctionComponent, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { useUserSettings } from 'features/settings/hooks';

import { AuthenticationScheme } from '../constants';
import { useAuthentication } from '../hooks';

export const OidcSignIn: FunctionComponent = () => {
  const { activeScheme, oidcScheme } = useAuthentication();

  const navigate = useNavigate();
  const { homePageUrl } = useUserSettings();

  useEffect(() => {
    if (activeScheme !== AuthenticationScheme.OIDC || homePageUrl == null) {
      return;
    }

    const redirectUrl = oidcScheme.getRedirectState() ?? homePageUrl;

    // Check if the URL is internal (starts with / or is same origin)
    const isInternalUrl = redirectUrl.startsWith('/') || redirectUrl.startsWith(window.location.origin);

    if (isInternalUrl) {
      // For internal URLs, use React Router navigation to stay within the app
      const path = redirectUrl.startsWith('/') ? redirectUrl : new URL(redirectUrl).pathname + new URL(redirectUrl).search + new URL(redirectUrl).hash;
      navigate(path, { replace: true });
    } else {
      // For external URLs, use window.location.href
      window.location.href = redirectUrl;
    }
  }, [activeScheme, oidcScheme, homePageUrl, navigate]);

  return null;
};

OidcSignIn.displayName = 'OidcSignIn';
